<template>
    <div id="app">
        <transition name="app-slide-right">
            <keep-alive>
                <router-view/>
            </keep-alive>
        </transition>
    </div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style lang="scss">
    #app {
        font-family: "DIN Regular", 'DAvenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        // background: #030F1B;
        background: #fff;
        @extend .abs_full_screen;

    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }



    /*自定义字体开始*/
    /*    字体引入*/
    /*@font-face {*/
    /*    font-family: 'DIN Regular';*/
    /*    src: url('./assets/fonts/DINPro-Regular.eot');*/
    /*    src: url('./assets/fonts/DINPro-Regular.woff') format('woff'),*/
    /*    url('./assets/fonts/DINPro-Regular.otf');*/
    /*}*/

    /*@font-face {*/
    /*    font-family: 'DIN Medium';*/
    /*    src: url('./assets/fonts/DINPro-Medium.eot');*/
    /*    src: url('./assets/fonts/DINPro-Medium.woff') format('woff'),*/
    /*    url('./assets/fonts/DINPro-Medium.otf');*/
    /*}*/

    /*!*    思源黑体*!*/
    /*@font-face {*/
    /*    font-family: 'SYYH';*/
    /*    src: url("./assets/fonts/SourceHanSansCN-Regular.otf");*/
    /*}*/
    /*@font-face {*/
    /*    font-family: 'SYYH_LIGHT';*/
    /*    src: url("./assets/fonts/SourceHanSansCN-Light.otf");*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue